var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconModuleAlerts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.48 13.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3,13.17H.18c-.06,0-.12-.03-.16-.09-.03-.05-.04-.12,0-.18L6.58.09c.06-.12.26-.12.33,0l6.56,12.81c.03.06.03.12,0,.18-.03.05-.09.09-.16.09ZM.48,12.8h12.52L6.74.58.48,12.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74,9.33c-.1,0-.18-.08-.18-.18V3.96c0-.1.08-.18.18-.18s.18.08.18.18v5.19c0,.1-.08.18-.18.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71,11.47c-.4,0-.73-.33-.73-.73s.33-.73.73-.73.73.33.73.73-.33.73-.73.73ZM6.71,10.37c-.2,0-.37.16-.37.37s.16.37.37.37.37-.16.37-.37-.16-.37-.37-.37Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModuleAlerts);
export default __webpack_public_path__ + "static/media/icon_module_alerts.baa82894126f61dc3f76fb6d03c34017.svg";
export { ForwardRef as ReactComponent };